import Button from 'components/base/Button'
import { FC } from 'lib/component-utils'
import Container from 'components/landing/Container'
import { MaxGradientIcon, TelegramIcon } from 'components/icons'

const TelegramBanner: FC = () => {
  return (
    <Container className="!pt-12 !pb-14 relative overflow-hidden text-black bg-gradient-to-tr from-primary-100 via-primary-200 to-primary-300">
      <div className="relative w-full px-2 sm:px-10 lg:px-8">
        <h2 className="text-2xl font-medium">Следите за новостями Sellmonitor</h2>
        <div className="mt-4 space-y-1 text-base">
          <p className="max-w-[70ch]">
            В нашем канале в Telegram и Макс — все новости маркетплейсов, разбор обновлений сервиса,
            а также полезные материалы и фишки для селлеров
          </p>
        </div>
        <div className="flex flex-wrap gap-3 mt-8">
          <Button
            as="a"
            target="_blank"
            rel="noreferrer nofollow"
            href="https://t.me/+JLtYFNWTAEE4NWIy"
            theme="primary"
            className="w-fit h-[42px] !border-transparent !bg-[#24A1DE] hover:!brightness-95"
          >
            Перейти в Telegram
          </Button>
          <Button
            as="a"
            target="_blank"
            rel="noreferrer nofollow"
            href="https://max.ru/id7727492799_biz"
            theme="primary"
            className="w-fit h-[42px] !border-transparent !bg-[#2E5CF4] hover:!bg-[#284FD4]"
          >
            Перейти в Макс
          </Button>
        </div>

        <div className="absolute inset-y-0 items-center justify-center hidden gap-5 py-4 pl-4 pr-8 my-auto bg-white rounded-full h-fit sm:right-10 lg:right-8 xl:flex">
          <TelegramIcon className="size-32 shrink-0 text-[#24A1DE]" />
          <MaxGradientIcon className="size-20 shrink-0" />
        </div>
      </div>
    </Container>
  )
}

export default TelegramBanner
